import { create } from 'zustand';
import { IUserData } from '@/lib/interface';

interface ProfileUserState {
    userData: IUserData | null;
    setUserData: (userData: IUserData | null) => void;
}

export const useProfileUserStore = create<ProfileUserState>((set) => ({
    userData: null,
    setUserData: (userData) => set({ userData }),
}));
